export const ReleaseNotesData = [
  {
    version: "3.2.9",
    releaseData: "2025-07-02",
    newFeatures: [
      {
        title: "Custom Weather Limits",
        description: "You can now define weather limits specific to individual vessels. This allows the Voyage Execution Team to tailor weather thresholds per vessel, enhancing operational flexibility and safety. These custom limits are accessible via the Weather Limits page. When set, Custom Weather Limits will override the default Company Limits for the selected vessel and will be used to trigger Heavy Weather Alarms."
      },
  ]
}, 
  {
    version: "3.2.8",
    releaseData: "2025-06-25",
    newFeatures: [
      {
        title: "Enabling copy of vessel names when utilizing the vessel list section.",
        description: "Provided an option to copy the vessel names from vessel list"
      },
      {
        title: "Ability to share Custom filters among other users.",
        description: "Share filters option is enabled in custom filters.We can share filters to one or more users."
      },
     
    ],
     bugFixes: [
      {
        title: "Missing Pink dotted lines on the route indicating Parametric/Synchronized rolling.", 
        description: "Missing roll indication in route is fixed. All the cordinate with roll risk will be indicated with pink dotted lines on the route."
      },
      {
        title: "Vessel list retain filter settings.", 
        description:"Fixed the vessel list misisng issue for the filter"
      },
      {
        title: "Missing Weather limits from Cloud Vessels", 
        description:
        "Weather limits will dipslay for cloud vessels"
      },
      {
        title: "Missing time stamp of submission of Basic Plans.", 
        description:"Time stamp of submission of Basic Plans will be displayed in the vessel over view page."
        },
  ]
}, 
  {
    version: "3.2.7",
    releaseData: "2025-06-12",
     bugFixes: [
      {
        title: "Passage plan info for basic vessels", 
        description:
        "Last passage plan updated info will be displaying in the vessel overview page for basic vessels."
      },
      
  ]
},
  {
    version: "3.2.6",
    releaseData: "2025-06-10",
    newFeatures: [
      {
        title: "Notification banner when a cloud vessel is offline for over 3 days.",
        description: "VET will be displayed with a notification if any cloud vessel is offline for 3 days."
      },
      {
        title: "Auto-email sent to vessel when vessel is offline for over 3 days.",
        description: "Autom email will trigger to vessel to if the vessel is offline for over 3 days."
      },
     
    ],
     bugFixes: [
      {
        title: "plotting of IDL crossing route", 
        description:
        "Fixed the route plotting issue if it crosses 180 degrees East/West (IDL)."
      },
      {
        title: "weather routing activity log formatting", 
        description:
        "Fixed the log missing issue in WR activity log. Also, fixed the formatting issue of preformance/safety check"
      },
  ]
},
  {
    version: "3.2.5",
    releaseData: "2025-05-08",
    newFeatures: [
      {
        title: "Weather Routing Integration",
        description: "Users can now view alarm and notification logs related to weather routing directly within the platform."
      },
      {
        title: "Vessel-Specific Master Data Restructuring",
        description: "Vessel-specific master data is now organized under each vessel’s name. Users can expand accordions to view detailed information."
      },
      {
        title: "ETA/ETD Pilot Information in Schedule View",
        description: "Fields such as ETD From Position, ETD Pilot Off Position, ETA To Position, and ETA Pilot Position from both Passage Plans and GSIS are now automatically displayed on the schedule card in Fleet Voyage using the latest scheduling data."
      },
      {
        title: "Mediterranean ECA zone",
        description: "The Mediterranean Emission Control Area (ECA) has been added as a selectable layer on the map."
      }
    ],
     bugFixes: [
      {
        title: "Vessel's best position", 
        description:
        "Vessel's best position (i.e. own position) rather than vessel’s latest position source. (This issue was affecting only one vessel). "
      
    }
  ]
},
  {
    version: "3.2.4",
    releaseData: "2025-04-09",
    newFeatures: [
      {
        title: "Logout Option", 
        description: "The logout option is now available in the top right corner of the application."
  
      },
      {
        title: "Custom filter - Select All", 
        description: "Enabled Select All feature for custom filters which helps the user to select all available vessels from search results in custom filter view "
  
      },
    ],
    bugFixes: [
      {
        title: "Measuring tool resetting", 
        description:
        "Measuring tool will reset when the user switches off."
      },]
  },
  {
    version: "3.2.3",
    releaseData: "2025-03-05",
    newFeatures: [
      {
        title: "Clickable FV Logo",
        description: "The application logo is now clickable and redirects to the Landing View for easy navigation."
  
      },
    ],
    bugFixes: [
      {
        title: "Proper vessel name display in alarms popup [VET]", 
        description:
        "The Heavy Weather and Parametric Roll Alarms popups now display the correct vessel name."
      },
      {
        title: "UTC Timestamp Standardisation", 
        description:
        "The latest Passage Plan and Weather Forecast timestamps are now displayed in UTC."
      }]
  },
  {
    version: "3.2.2",
    releaseData: "2025-02-12",
  
    bugFixes: [
      {
        title: "Past trail information when passing date line", 
        description:
        "The tooltip is displaying on past trail, also when vessel has passed the date line."
      },
      {
        title: "Retaining zoom when clicking on a vessel", 
        description:
        "The zoom on the map is retained after clicking on the vessel."
      }]
  },
    {
      version: "3.2.1",
      releaseData: "2025-02-05",
    
      newFeatures: [
        {
          title: "Heavy weather and parametric roll tooltips",
          description: "The ETA is now in hours instead of days."
        },
        {
          title: "New Whale Zone added",
          description: "Aleutian Island Archipelago whale zones added to the Whale Zone layer."
        },
      ],
      bugFixes: [
        {
          title: "Filters persistence", 
          description:
          "Filters remain applied after using the List tool."
        },
        {
          title: "No plan alarms", 
          description:
          "No plan alarms are automatically ended when vessel is in port."
        }]
    },

    {
    version: "3.2.0",
    releaseData: "2025-01-15",
  
    newFeatures: [
      {
        title: "Distance Measuring Tool",
        description: "Upgraded to provide a better usability and distance on-the-go."
  
      },
    ],
    bugFixes: [
      {title: "Custom Filter", 
        description:
         "Vessel search are now capturing all vessels."
      },
      {
        title: "[VET users only] Heavy weather & parametric roll alarm notification ", 
        description:
         "Vessel name is no longer displayed as “undefined” and Time format fixed "
      },
      {
        title: "Off Track Alarm", 
        description:
         "Resolving issues where an alarm was raised for a single position."
      },
      {
        title: "Time since last position indicator", 
        description:
         "Now considering all AIS providers to give the time since last position know by the application."
      }]
    },

    {
    version: "3.1.9",
    releaseData: "2025-12-19",
    newFeatures: [
      {
        title: "New route filter in filter window",
        description: "Ability to filter vessels based on the route being sailed: StarRoute, Own Route and/or WNI route(integration in progress, estimated completion in February 2025)."
  
      },
      {
        title: "Terminal automatic creation",
        description: "When a new terminal code is detected in a schedule, it will be automatically created in the system, avoiding manual work and missing port calls in the schedules."
  
      },
    ],    
    bugFixes: [
      {    
        title: "Weather alarm timestamp discrepancies", 
        description:
         "Fixing timestamp discrepancies noticed on weather alarms."
      },
      {
        title: "StarConnect position sensor unavailable", 
        description:
         "A temporary fix to restart the StarConnect position service if outage is detected."
      },
    ],
  },
  {
    version: "3.1.8",
    releaseData: "2024-12-12",
  
    newFeatures: [
      {
        title: "Custom filter improvement",
        description: "Usability improvement in creating and navigating custom filters."
      },
    ],
    bugFixes: [
      {
        title: "Weather alarms timestamps", 
        description:
         "The discrepancies on the weather alarm timestamps has been resolved."
      },
      {
        title: "Vessel route crossing date line zoom issues", 
        description:
         "Vessels' routes are now showing on all zoom levels when plan is crossing the Date line.z"
      },
      {
        title: "Plan plotting issue fix ", 
        description:
         "The issue related to plotting the plan on the map has been resolved."
      }

    ],
  },
  {
    version: "3.1.7",
    releaseData: "2024-11-13",
  
    newFeatures: [
      {
        title: "Heavy weather and parametric roll alarms",
        description: "Process timestamps added to the heavy weather and parametric roll alarms. Information about latest weather forecast onboard and latest plan update added to the vessel details page."
      },
      {
        title: "Interface improvements",
        description:
          "[VET users only] When new items enter the Activity Log, a red dot will appear on the icon. Timer for session expiry is replaced by a notification 5 minutes prior to automatic logout. The vessel alarm log will display by default 1 month old data with the ability to filter on dates."
      },

    ],
    bugFixes: [
      {
        title: "Vessel name correctiopn in chart tooltip", 
        description:
         "Names showed when hovering over a vessel are now aligned with the latest known and official vessel name."
      }
    ],
  },
  {
    version: "3.1.6",
    releaseData: "2024-10-16",
  
    bugFixes: [
      {
        title: "Parametric Roll indication in route view",
        description:
         "All the parametric rolls are now displaying in route view with tooltip."
      }
    ],
  },
  {
    version: "3.1.5",
    releaseData: "2024-10-07",
    newFeatures: [
      {
        title: "Custom filter - edit:",
        description: "Users can now edit a previously created custom filter."
      },
      {
        title: "Vessel list to custom filter:",
        description:
          "Users can now use the vessel list feature and create a custom filter from it."
      },

    ],
    bugFixes: [
      {
        title: "Maersk Bayete unsearchable",
        description:
         "Maersk Bayete name was corrected and is now searchable."
      },
      {
        title: "Simulation timeline automatic reset",
        description:
         "The timeline will no longer reset automatically."
      }
    ],
  },

  {
    version: "3.1.4",
    releaseData: "2024-10-04",
    bugFixes: [
      {
        title: "Latest forecast version for fetching weather information",
        description: "Fixed the forecast version used for fetching latest weather information"
      },
    ]
  },
  {
    version: "3.1.3",
    releaseData: "2024-09-26",
    bugFixes: [
      {
        title: "Plotting routes that crossing the International Date Line",
        description:
         "Fixed the route  disappearing issue if it crosses 180 degress East/West (IDL) and if 180 degress is outside the screen"
      },
    ]
  },
  {
    version: "3.1.2",
    releaseData: "2024-09-24",
    bugFixes: [
      {
        title: "Weather alarm data discrepancy fix",
        description:
         "Fixed discrepancies between the spot weather data and weather alarm data"
      },
    ]
  },
  {
    version: "3.1.1",
    releaseData: "2024-09-16",
    newFeatures: [
      {
        title: "Warnings for outdated weather forecasts older than 24 hours",
        description: "If the weather is outdated for more than 24 hours, user will be able to see a warning message."
      },
      {
        title: "Vessel overview page deeplinking from Activity Log",
        description: "User can click on Activity log feed and open the corresponding vessel detail view."
      },
      {
        title: "Simulation enabled for Basic vessels",
        description:
         "User will be able to see basic vessel's simulation if the plan is available."
      },

    ],
    bugFixes: [
      {
        title: "TEU value in vessel overview page",
        description:
         "TEU value will be available in vessel overview page."
      },
      {
        title: "Removed empty check boxes from the bottom of the Fleet application landing page",
        description:
         "Map will display properly without check boxes."
      },
      {
        title: "Parametric roll alarm - tooltip correction",
        description: "Typo in Parametric roll tooltip is fixed now."
      }
    ],

  },
  {
    version: "3.1.0",
    releaseData: "2024-09-09",
    newFeatures: [
      {
        title: "Multiple vessels simulation",
        description: "The Fleet application now supports simulation for up to 20 vessels simultaneously. Users can apply filters and activate the timeline to view the simulation. The feature includes Play, Next, and Previous controls for smooth navigation. Simulated vessels are represented by yellow ship icons, and the Vessel Overview page supports single vessel simulations."
      },
      {
        title: "Custom filter",
        description:
          "The filter functionality has been enhanced with a custom filter section. Users can now Save, Delete, View, and Apply filters, along with the option to group IMOs for better organization."
      },

    ],
    bugFixes: [
      {
        title: "Plotting of IDL crossing route",
        description:
         "The issue related to plotting routes that cross the International Date Line (IDL) has been resolved."
      }
    ],

  },
  {
    version: "3.0.1",
    releaseData: "2024-09-05",
    bugFixes: [
      {
        title: "Retaining previosuly selected Map View",
        description: "User will be able to see the previoulsy selected map view after refreshing/re-login the page.",
      },
      {
        title: "Parametric roll tooltip in route view",
        description:
          "The tooltip for parametric roll in the route view is now displaying with correct information.",
      },
      {
        title: "Activity logs",
        description:
          "Activity logs will be available once it loads all the vessels information.",
      },

      {
        title: "Weather limits in vessel overview",
        description:
          "For non-pilot vessel's weather limits will be vessel set avoidance and warning values.",
      }

    ],

  },
  {
    version: "3.0.0",
    releaseData: "2024-09-04",
    newFeatures: [
      {
        title: "Heavy Weather and Parametric Roll Alerts",
        description: "VET users will receive a popup displaying vessel details along with alarm information. VET users can choose to Accept or Remind Me Later. If “Accept” is selected, a green banner will appear with the relevant information. Snoozed alarms will reappear every hour if still valid and not accepted by any other VET/Vessel users",
      },
      {
        title: "Activity Logs",
        description:
          "Users can access activity logs from the top bar. Activity logs contain all valid heavy weather and parametric roll alarms. Each active alarm has an “Accept” button. If a vessel or VET user has already accepted an alarm, the activity logs will display the acceptance information. Each alarm has options to add or view notes. Activity logs include filter and search options. Filters help toggle between active and in-progress alarms, while search assists in finding IMO-specific alarms."
      },
      {
        title: "New Filters",
        description:
          "New filters are introduced for heavy weather and parametric roll alerts, along with time-critical toggles.",
      },

      {
        title: "Filter List View - New Icons",
        description:
          "Vessels experiencing heavy weather and parametric roll now have a new icon for indication.",
      },

      {
        title: "Route View - Heavy weather and Parametric roll indication",
        description:
          "Users can see heavy weather and parametric roll indications on the plan map view. Hovering over the map will display a tooltip with avoidance information.",
      },

      {
        title: "Heavy Weather Alarm Limits",
        description: "VET and Fleet Safety users can access heavy weather alarm limits from the settings. VET users have read access to validate the limit data. Fleet Safety users have read and write access to update the information. “View History” will show data changes made by users for each field."
      },

      {
        title: "Weather Limit Info",
        description: "The vessel overview page now displays vessel threshold and Maersk policy information in the weather limit section."
      },

    ],

  },
  {
    version: "2.3.4",
    releaseData: "2024-07-31",
    newFeatures: [
      {
        title: "Map View",
        description:
          "Users can choose between several map views. Navigate to the “Map View” button in the top right corner to select the appropriate view.",
      },
      {
        title: "Saved Filters",
        description:
          "Users can create and select a customized “Saved Filter” based on the predefined filters. To create a saved filter, select first the filters to apply, then name and save the filter.",
      },
      {
        title: "Vessel plan ETA information",
        description:
          "The ETA for Pilot and Berth available in the latest vessel passage plan is now added to the vessel information, when selected. Please note the time zone is based on the arrival port. For Vessel Voyage Basic vessels, only the ETA Pilot is available.",
      },

      {
        title: "Navigational zones updated",
        description:
          "The following zones has been updated: 1. Baltic Sea - removal of the no-sail zones (related to the Nord Stream gas leakage in 2022), 2. Oman - Port of Duqm - new whale zone, 3. North Western Mediterranean - new whale zone.",
      },
    ],

    bugFixes: [
      {
        title: "Past trail navigation",
        description:
          "When clicking on a vessel route past trail, the user is no longer taken back to the vessel current position.",
      },
      {
        title: "Zone tooltip",
        description:
          "The information provided when hovering over a map layer zone (for instance an ECA/SECA zone) is now updated when hovering over an adjacent zone.",
      },
      {
        title: "Updated alarm dropdown - Voyage Execution Team users",
        description:
          "For VET users, when dismissing an alarm, the reason 'Select a reason for alarm' has been removed from the dropdown list.",
      },
    ],
  },
  {
    version: "2.3.3",
    releaseData: "2024-06-13",
    newFeatures: [],

    bugFixes: [
      {
        title: "San Francisco Bay Area Whale conservation area",
        description:
          "Zone updated to 2024 coverage area, Area in force 01 May to 31 December, maximum 10 knots.",
      },
    ],
  },
  {
    version: "2.3.2",
    releaseData: "2024-06-10",
    newFeatures: [
      {
        title: "Net Promoter Score",
        description:
          "In short, the Net Promoter Score (NPS) is a rating system enabling the users to provide a rating of Fleet Voyage on a monthly basis with a scale from 1 to 5. It is also possible to add comments to enrich the feedback. The Net Promoter Score will be used to track user satisfaction and capture issues reported by users filling in the comment field.",
      },
      {
        title: "Export vessel list to excel",
        description:
          "It is possible in Fleet Voyage to draw a square or polygon and create a list of all vessels inside this figure. Until now, the user could copy the vessel e-mail addresses to Outlook, but with the new add on feature, it is possible to export the vessel list to excel as well with relevant vessel data.",
      },
      {
        title: "New option in alarm CLF dropdown ",
        description:
          "New option 'Inaccurate Alarm' is added in the alarm CLF dropdown.",
      },
    ],

    bugFixes: [
      {
        title: "Weather information not showing in the past trail bubble",
        description:
          "When trying to see the weather information in the past trail bubble the loader keeps spinning and no data will show.",
      },
      {
        title: "Vessels retaining in list after user close the drawer ",
        description:
          "Vessel list data will be cleared once user close the drawer now.",
      },
    ],
  },
  {
    version: "2.3.1",
    releaseData: "2024-05-14",
    bugFixes: [
      {
        title: "Vessel list drag and copy",
        description:
          "Bug fix solving copying vessels after crossing axis line.",
      },
    ],
  },
  {
    version: "2.3.0",
    releaseData: "2024-04-22",
    newFeatures: [
      {
        title: "Vessel list - Email",
        description:
          "Vessel email is now included with a copy emails functionality that saves it to the clipboard.",
      },
      {
        title: "Vessel list – Selection",
        description:
          "Vessel list selection is now based on the applied filters and not limited to Maersk vessels only.",
      },
      {
        title: "Remaining distance",
        description:
          "The vessel panel now displays the total, sailed and remaining distance.",
      },
      {
        title: "Vessel panel UI optimization",
        description:
          "Show/hide functionality is added for maximized screen utilization.",
      },
      {
        title: "General UI improvements",
        description: "Alarm icons in filter list & text font alignment.",
      },
      {
        title: "Release notes",
        description:
          "Style and functionality improvements including easy access to previous release notes and sticky close button.",
      },
    ],

    bugFixes: [
      {
        title: "Whale zones updates",
        description:
          "San Francisco & Monterey Bay area, Santa Barbara channel, Gulf of St. Lawrence, Roseway Basin.",
      },
      {
        title: "ETA deviation",
        description: "Bug fix solving cases where reason field would be empty.",
      },
    ],
  },
  {
    version: "2.2.1",
    releaseData: "2024-03-14",
    bugFixes: [
      {
        title: "Schedule time",
        description:
          " UTC and local time has been updated to match GSIS time zones.",
      },
      {
        title: "Unable to meet ETA",
        description:
          "Improved performance and fetching vessel feedback in tooltip.",
      },
    ],
  },

  {
    version: "2.2.0",
    releaseData: "2024-03-04",
    newFeatures: [
      {
        title: "Unable to meet ETA",
        description:
          "Unable to meet ETA: It is now possible to select vessels marked 'Unable to meet ETA' using the alarms filter. A red progress bar signifies vessels unable to meet ETA, while yellow indicates feedback received from the vessel. Hovering over the schedule bar provides relevant information, including reasons or comments submitted by the vessel. Additionally, the Alarm log keeps a history of ETA deviations.",
      },
      {
        title: "Premium vessel Icon",
        description:
          "Voyage premium vessels are now highlighted using a star icon.",
      },
      {
        title: "Enhanced navigation",
        description:
          "Opening a filter group now automatically directs the view to their respective sub-filters.",
      },
    ],
    bugFixes: [
      {
        title: "Untimely logouts",
        description: "UTC conversion fixing the frequent logout issue",
      },
      {
        title: "Landing page scrollbar",
        description:
          "Removed the scroll bar previously visible on the application landing page.",
      },
      {
        title: "Vessel Visibilit",
        description:
          "Resolved issue where vessels did not appear in the general view but were visible in the search list.e",
      },
      {
        title: "GSIS ETA",
        description:
          "Fixed GSIS ETAs on the vessel page when converting from UTC to LT.",
      },
      {
        title: "Performance graph",
        description:
          "Corrected vessel indicating the wrong Pilot Off position in the performance graph..",
      },
    ],
  },
];
